const getApiUrl = () => {
  const envApiUrl = process.env.REACT_APP_BASEURL;

  const apiUrlFromMetaTag =
    document.querySelector("meta[name='api-url']")?.getAttribute("content") ??
    "{{apiUrl}}";

  const hasApiUrlMetaTag = apiUrlFromMetaTag !== "{{apiUrl}}";

  const baseUrlString = hasApiUrlMetaTag ? apiUrlFromMetaTag : envApiUrl;

  const apiOrigin = new URL("/", baseUrlString).origin;

  const baseUrl = handleOrigin(apiOrigin, hasApiUrlMetaTag);

  return baseUrl;
};

export default getApiUrl;

const handleOrigin = (baseUrl: string, hasApiUrlMetaTag: boolean) => {
  const origin = window.location.origin;
  const env = process.env.REACT_APP_ENV;

  if (
    !origin.includes("monkey-tie") &&
    !origin.includes("localhost") &&
    !hasApiUrlMetaTag
  ) {
    const split = origin.split(".");
    split[0] = `https://mtback-${env}`;
    baseUrl = split.join(".");
  }
  return baseUrl;
};

export const apiUrl = getApiUrl();
